import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { InfiniteScrollDirective } from '@df/module-infinite-scroll/infinite-scroll.directive';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { DragScrollDirective } from '@df/ui/common/drag-scroll.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { PartitionPipe } from '@df/ui/common/partition.pipe';
import { OrdinalPipe } from '@df/ui/display/ordinal.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent } from '@icms/core/content';
import { FilterPrimaryTagComponent } from '../../../../catalog/ui/listing/filter/primary-tag/filter-primary-tag.component';
import { ActionComponent } from '../../../../ui/api/action.component';
import { CmsBlogComponentListingAbstract } from '../listing/cms-blog-component-listing.abstract';
import { CMS_BLOG_COMPONENT_LISTING_V2_CONFIG } from './cms-blog-component-listing-v2.config';
import { NCmsBlogComponentListingV2 } from './cms-blog-component-listing-v2.interface';

@Component({
    selector: 'cms-blog-component-listing-v2',
    templateUrl: './cms-blog-component-listing-v2.component.html',
    standalone: true,
    imports: [
        ActionComponent,
        CommonModule,
        DfImageDirective,
        DragScrollDirective,
        FilterPrimaryTagComponent,
        GridModule,
        HrefComponent,
        ICmsClientModule,
        InfiniteScrollDirective,
        OrdinalPipe,
        PartitionPipe,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsBlogComponentListingV2Component>(CMS_BLOG_COMPONENT_LISTING_V2_CONFIG)
export class CmsBlogComponentListingV2Component extends CmsBlogComponentListingAbstract {
    override component!: NCmsBlogComponentListingV2.IData;
}
